import { ComponentInternalInstance, getCurrentInstance, nextTick, ref } from '@vue/composition-api';
import { FormInstance } from 'tdesign-vue/es/form/form-item';

/**
 *
 * @param $component
 */
export const useBeforeLeave = () => {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  // 获得组件实例
  const vm = currComponent.proxy;
  // cache
  const targetTabValue = ref('');
  // cache
  let changeTabsResolve: Function;
  // cache
  let changeTabsReject: Function;

  // 确定对话框的状态
  const confirming = ref(false);

  const toggleMethods = {
    /**
     *
     * @param toTabValue 要前往的tabValue，若为close则代表要关闭dialog
     */
    beforeLeave: (toTabValue: string): Promise<string> => {
      targetTabValue.value = toTabValue; // 缓存目标tab页
      confirming.value = true; // 展开confirm
      return new Promise((resolve, reject) => {
        changeTabsResolve = resolve;
        changeTabsReject = reject;
      });
    },
    // afterSave: () => {
    //   confirming.value = false;
    //   nextTick(() => {
    //     toggleMethods.updateTabs();
    //   });
    // },
    onCancel: () => {
      confirming.value = false;
      nextTick(() => {
        toggleMethods.updateTabs();
      });
    },
    onConfirm: () => {
      confirming.value = false;
      nextTick(() => {
        const { form } = vm.$refs;
        form && (form as any as FormInstance).submit();
      });
    },
    updateTabs: () => {
      if (targetTabValue.value) {
        changeTabsResolve(targetTabValue.value);
      }
    },
  };
  return {
    confirming,
    toggleMethods,
  };
};
